/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_TitleInputs */

const es_user_profile_devices_title = /** @type {(inputs: User_Profile_Devices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivos`)
};

const en_user_profile_devices_title = /** @type {(inputs: User_Profile_Devices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices`)
};

/**
* | output |
* | --- |
* | "Devices" |
*
* @param {User_Profile_Devices_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_title = /** @type {((inputs?: User_Profile_Devices_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_title(inputs)
	return en_user_profile_devices_title(inputs)
});
export { user_profile_devices_title as "user.profile.devices.title" }